import { RotateCwIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

import styles from './ContextSectionWrapper.module.scss';

type Props = { title: string; onClick: () => void; children?: React.ReactNode; hideIcon?: boolean };

export const ContextSectionWrapper = ({ title, onClick, hideIcon = false, children }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper__header}>
        <span className="text-sm leading-5 font-medium text-foreground-muted">{title}</span>
        {!hideIcon && (
          <Button
            variant="ghost-neutral"
            size="icon-sm"
            aria-label={t('try_it.reset')}
            onClick={onClick}
          >
            <RotateCwIcon size={16} />
          </Button>
        )}
      </div>

      {children && <div className="mt-4">{children}</div>}
    </div>
  );
};
